const DrawerCSSProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <div data-vaul-drawer-wrapper="" className="h-full bg-dark">
      <div className="relative flex flex-col h-full">{children}</div>
    </div>
  );
};

export default DrawerCSSProvider;
